import { fetchOptions } from "./api";
import { getApiKey } from "./../selectors";

export const getProductSuites = () => {
    return (dispatch, getState) => {
        return dispatch({
            type: "GET_PRODUCT_SUITES",
            payload: fetchOptions(getApiKey(getState()), "GetProductSuites")
        });
    };
};



// WEBPACK FOOTER //
// ./src/actions/itemSelector.js